/* eslint-disable @typescript-eslint/indent */
import { useMutation } from '@apollo/client';

import { registerSupplierMutation } from './gql';
import { SupplierRegisterArgs, MutationResult } from './types';

export const useRegisterSupplierGql = () => {
  const [runRegisterSupplierMutation, { data, loading, error }] = useMutation<MutationResult, SupplierRegisterArgs>(
    registerSupplierMutation,
    {
      context: {
        headers: {
          userFunctionKey: '9f61408e3afb633e50cdf1b20de6f466'
        }
      }
    }
  );

  return {
    runRegisterSupplierMutation,
    loadingRegisterSupplier: loading,
    message: data?.message || '',
    errorRegisterSupplier: error
  };
};
